// components/Common/Loader.js
import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loader = ({ size = 40, color = "#a33434", fullScreen = false }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: size, color }} spin />;

  return (
    <div
      className={`flex justify-center items-center ${
        fullScreen ? "h-screen w-screen" : "py-20"
      }`}
    >
      <Spin indicator={antIcon} />
    </div>
  );
};

export default Loader;
